import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note31',
  templateUrl: './note31.component.html',
  styleUrls: ['./note31.component.scss'],
})
export class Note31Component implements OnInit {
  note31Form: FormGroup;
  calculativeData: any;

  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note31) {
        this.calculativeData = data.response.calculativeData;

        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes31(data.response.userInputData.data);
        }
      }
    });
  }

  editNotes31(res): void {
    this.note31Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
    });
  }

  setForm(): void {
    this.note31Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}
